import { useSelector } from 'react-redux';
import { Promotion } from '..';
import { Heading } from '../../../components';

const RegionView = () => {
  const { currentDevelopment } = useSelector((state) => state.general);
  const promotions = useSelector((state) => state.promotions);

  const parentPromotions = promotions.filter(
    (promotion) => promotion.belongsTo == currentDevelopment.parentId,
  );

  const regionPromotions = promotions.filter(
    (promotion) => promotion.belongsTo == currentDevelopment.id,
  );

  return (
    <>
      <div className='parent-promotions'>
        <Heading label={`Created by head office (uneditable)`} />

        <div className={'promotions-list'}>
          {parentPromotions.map((promotion) => {
            return <Promotion key={promotion.id} belongsTo={promotion.belongsTo} promotionToggle={promotion.enablePromotion} isParent {...promotion} />;
          })}
        </div>
      </div>

      <Heading label={`Created by ${currentDevelopment.name}`} />

      <div className={'promotions-list'}>
        {regionPromotions.map((promotion) => {
          return <Promotion key={promotion.id} belongsTo={promotion.belongsTo} promotionToggle={promotion.enablePromotion} {...promotion} />;
        })}
      </div>
    </>
  );
};

export default RegionView;
